import { useLocation } from "react-router-dom"

const CommonItemTag = ({ tag }) => {

  const { pathname } = useLocation();

  const getTagClass = (tag) => {
    switch (tag) {
      case 'identity pack':
        return 'cards-list__block-item-tag--identity'
      case 'prediction pack':
        return 'cards-list__block-item-tag--prediction'
      case 'Not Redeemable':
        return 'cards-list__block-item-tag--not-redeemable'
      case 'Redeemable':
        return 'cards-list__block-item-tag--redeemable'
      case 'Not Listed':
        return 'cards-list__block-item-tag--not-listed'
      case 'Resolved True':
        return 'cards-list__block-item-tag--resolved-true'
      case 'Resolved False':
        return 'cards-list__block-item-tag--resolved-false'
      default:
        return ''
    }
  }
  if (tag && tag === 'Not Listed' && pathname.includes('/marketplace')) {
    return null
  } else if (tag !== '' && tag !== 'For Sale') {
    return (
      <span className={`cards-list__block-item-tag ${getTagClass(tag)}`}>
        {tag}
      </span>
    )
  }
}

export default CommonItemTag;
